/* eslint-disable */
import React, { useEffect } from 'react';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { RequestHistory } from 'components/request-history';

export const RequestHistoryPage: React.FC = () => {
    useEffect(() => {
        document.title = 'Mes demandes';
    }, []);

    return (
        <ContentSection pageWrapSize="medium">
            <RequestHistory />
        </ContentSection>
    );
};
